export default {
  namespased: true,
  state: {
    sellers: [],
  },
  getters: {
  },
  actions: {
  },
  mutations: {
    addSeller: function(state,seller){
      const s = {
        id: '',
        status: 'seller',
        office: 0,
        is_business: '',
        name: '',
        city: '',
        zip_code: '',
        address: '',
        id_card: '',
        id_card_authority: '',
        pesel: '',
        nip: '',
        krs: '',
        stock: '',
        company_name: '',
        company_city: '',
        company_zip_code: '',
        company_address: '',
        acceptance: false,
        proxy_name: '',
        proxy_city: '',
        proxy_zip_code: '',
        proxy_address: '',
        proxy_id_card: '',
        proxy_id_card_authority: '',
        proxy_pesel: '',
      };
      state.sellers.push(Object.assign({}, s, seller))
    },

    updateStoreSeller: function(state, seller){
      const seller_id = seller.id;
      state.sellers.map((seller) => {
        if(seller.id === seller_id){
          seller.stock = seller.stock.replace(/\s/g,'');
        }
      })
    },

    removeSeller: function( state, ev ) {
      const el = ev.target;
      const index = el.dataset.index;
      state.sellers.splice(index,1);
      if(state.sellers.length == 0){
        const s = {
          id: '',
          status: 'seller',
          office: 0,
          is_business: '',
          name: '',
          city: '',
          zip_code: '',
          address: '',
          id_card: '',
          id_card_authority: '',
          pesel: '',
          nip: '',
          krs: '',
          stock: '',
          company_name: '',
          company_city: '',
          company_zip_code: '',
          company_address: '',
          acceptance: false,
          proxy_name: '',
          proxy_city: '',
          proxy_zip_code: '',
          proxy_address: '',
          proxy_id_card: '',
          proxy_id_card_authority: '',
          proxy_pesel: '',
        };
        state.sellers.push(s)
      }
    },

    clearSellers: function( state, value=null){
      state.sellers = []
    }
  }
}